import React, { useState, useEffect } from "react";
import { CircularProgress, Box } from "@mui/material";

export const ScrutinyUnderProcess = () => {
  const [dots, setDots] = useState("");
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    const dotsInterval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 500);

    const blinkInterval = setInterval(() => {
      setBlink((prev) => !prev);
    }, 800);

    return () => {
      clearInterval(dotsInterval);
      clearInterval(blinkInterval);
    };
  }, []);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={5}>
      <Box mt={2} fontSize="20px" fontWeight="bold" style={{ opacity: blink ? 1 : 0.3 }}>
        Scrutiny under process{dots}
      </Box>
        <CircularProgress />
    </Box>
  );
};

